// extracted by mini-css-extract-plugin
module.exports = {"notification":"NotificationItem-module_notification_JxBRg","delete":"NotificationItem-module_delete_3ANfo"};